export default "__VITE_ASSET__BmBFeUVX__"